import React, {useRef, useState} from 'react'
import {Button, Input, NavDivider, Navigation, TOAST} from "retro/index";
import {get, post} from "App/Network/Axios";

export default function RegenerateCancellationChargeInvoiceController() {
    const TRANSID = useRef()
    const INVPREFIX = useRef()
    const AMOUNT = useRef()
    const GST = useRef()
    const [value,setValue] = useState(0)
    const [loading,setLoading] = useState(false)
    const CRNPREFIX = useRef()
    const REMARKS = useRef()
    return (
        <div>
            <Navigation backUrl={'back'} title="Regenerate Financial Cancellation Charges" />
            <NavDivider />
            <Input
                ref={TRANSID}
                type="text"
                label="Transaction Id"
                placeholder="Transaction Id"
            />
            <Input
                defaultValue="CNC"
                ref={INVPREFIX}
                type="text"
                label="Invoice Prefix"
                placeholder="Invoice Prefix"
            />
            <Input
                defaultValue="CNCR"
                ref={CRNPREFIX}
                type="text"
                label="Credit Note Prefix"
                placeholder="Credit Note Prefix"
            />
            <Input
                ref={AMOUNT}
                type="number"
                label={`Cancellation Charges`}
                placeholder="Cancellation Charges"
            />
            <Input
                ref={GST}
                type="number"
                label={`Gst Slab`}
                placeholder="Gst Slab"
            />
            <Input
                ref={REMARKS}
                defaultValue="Updating Disputed Cases Of Zero Rs"
                type="text"
                label="Remarks"
                placeholder="Remarks"
            />
            <Button
                onClick={()=>{
                    setLoading(true)
                    let gst = GST.current.value;
                    if(!gst) {
                        TOAST.error("Enter a valid gst amount")
                        return
                    }
                    let amount = AMOUNT.current.value;
                    if(!amount) {
                        TOAST.error("Enter a valid amount")
                        return
                    }
                    let transId = TRANSID.current.value;
                    if(!transId) {
                        TOAST.error("Enter a valid transaction id")
                        return
                    }
                    let inv = INVPREFIX.current.value;
                    if(!inv) {
                        TOAST.error("Enter a valid invoice id")
                        return
                    }
                    let crn = CRNPREFIX.current.value;
                    if(!crn) {
                        TOAST.error("Enter a valid credit note id")
                        return
                    }
                    let remarks = REMARKS.current.value;
                    if(!remarks) {
                        TOAST.error("Enter a valid remarks")
                        return
                    }
                    post(`/meta/${transId}/flight/regenerate/update/cancel`,{
                        crn,
                        slab:parseInt(gst,10),
                        inv,
                        amount:parseInt(amount,10),
                        remarks
                    },(e,r)=>{
                        setLoading(false)
                        if(r){
                            TOAST.success("Regeneration done successfully")
                            TRANSID.current.value = ""
                            INVPREFIX.current.value = ""
                            CRNPREFIX.current.value = ""
                        }else{
                            TOAST.handleError(e)
                        }
                    })
                }}
                className="btn-black btn-primary"
                margin="pd2 mt4"
                loading={loading}
            >
                Regenerate
            </Button>
        </div>
    )
}
